var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.575195 18C0.575195 27.9411 8.63407 36 18.5752 36C28.5163 36 36.5752 27.9411 36.5752 18C36.5752 8.05888 28.5163 0 18.5752 0C8.63407 0 0.575195 8.05888 0.575195 18Z",
    fill: "#F7646C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5104_16391)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.9082 10.6665H11.2415C10.2332 10.6665 9.41737 11.4915 9.41737 12.4998L9.4082 23.4998C9.4082 24.5082 10.2332 25.3332 11.2415 25.3332H25.9082C26.9165 25.3332 27.7415 24.5082 27.7415 23.4998V12.4998C27.7415 11.4915 26.9165 10.6665 25.9082 10.6665ZM25.9082 14.3332L18.5749 18.9165L11.2415 14.3332V12.4998L18.5749 17.0832L25.9082 12.4998V14.3332Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5104_16391"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(7.5752 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailLogo);
export default __webpack_public_path__ + "static/media/mailLogo.75d6f21f1aa3f4d91d3d538fb6d5d6eb.svg";
export { ForwardRef as ReactComponent };